import { SETISLOGIN, setIsLogin, SETUSERINF, SetUserInf } from '../../actions/login';

const initState = {
    isLogin: "",
}
//login status
export const loginStateReducer = (state = initState, action) => {
    switch (action.type) {
        case SETISLOGIN:
            return {
                ...state,
                isLogin: action.state
            }
        default:
            return state
    }
}


const initUserInfState = {
    userInfo: []
}

export const userInfStateReducer = (userInfo = initUserInfState, action) => {
    switch (action.type) {
        case SETUSERINF:
            return {
                ...userInfo,
                userInfo: action.userInfo
            }
        default:
            return userInfo
    }
}
